<div
  class="hd-cycle-center-block"
  [class.hd-cycle-center-block--clickable]="clickable()"
  [attr.role]="clickable() ? 'button' : null"
  [attr.tabindex]="clickable() ? 0 : null"
  (click)="onClick($event)"
  (keydown)="onKeydown($event)"
>
  <span class="hd-cycle-center-block__shape" [innerHTML]="shape()" aria-hidden="true"></span>
  <div class="hd-cycle-center-block__body">
    <p class="hd-cycle-center-block__text">
      <span class="hd-cycle-center-block__label">{{ label() }}</span>: <span [innerHTML]="text()"></span>
    </p>
    @if (causes().length > 0) {
      <!-- Activaties die dit center tijdelijk definiëren: glyph + poort-pil
           "30.5" (klik = poortinfo; de rest van het blokje = center-info). -->
      <span class="hd-cycle-center-block__causes" data-test-id="center-block-causes">
        @for (cause of causes(); track cause.gate + '.' + cause.line + cause.glyph) {
          <span class="hd-cycle-center-block__cause" [style.--cause-color]="cause.color ?? null">
            <span class="hd-cycle-center-block__cause-glyph" aria-hidden="true">{{ cause.glyph }}</span>
            <button
              type="button"
              class="hd-cycle-center-block__cause-gate"
              [attr.title]="cause.title"
              data-test-id="center-block-cause-gate"
              (click)="onCauseClick(cause, $event)"
            >{{ cause.gate }}.{{ cause.line }}</button>
          </span>
        }
      </span>
    }
  </div>
</div>
